import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [],
  templateUrl:
    './../../../../Presentation/components/navbar/navbar.component.html',
  styleUrl:
    './../../../../Presentation/components/navbar/navbar.component.scss',
})
export class NavbarComponent {}
